export const API_ROOT = '/api';

export function sessionToken() {
  return window.localStorage.getItem('platabus.token') || '';
}

export async function api(path, options = {}) {
  const { userActivity = false, ...requestOptions } = options;
  const headers = new Headers(requestOptions.headers || {});
  if (requestOptions.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  const token = sessionToken();
  if (token) headers.set('X-App-Token', token);
  if (userActivity) headers.set('X-User-Activity', '1');
  const response = await fetch(`${API_ROOT}${path}`, { ...requestOptions, headers });
  const contentType = response.headers.get('content-type') || '';
  const body = contentType.includes('application/json') ? await response.json() : await response.text();
  if (response.status === 401 && body?.detail === 'SESSION_IDLE_TIMEOUT') {
    window.dispatchEvent(new CustomEvent('platabus:session-expired'));
  }
  if (!response.ok) throw new Error(body?.detail || body?.error || body || `Error HTTP ${response.status}`);
  return body;
}

export const json = (method, path, payload, options = {}) => api(path, { method, body: JSON.stringify(payload), userActivity: options.userActivity ?? true, ...options });

export function saveSession(data) {
  window.localStorage.setItem('platabus.token', data.token || '');
  window.localStorage.setItem('platabus.user', JSON.stringify(data.user || {}));
  if (data.softphone) window.localStorage.setItem('platabus.softphone', JSON.stringify(data.softphone));
}

export function clearSession() {
  window.localStorage.removeItem('platabus.token');
  window.localStorage.removeItem('platabus.user');
  window.localStorage.removeItem('platabus.softphone');
}

export function mediaUrl(path) {
  return `${API_ROOT}${path}`;
}

// The browser must always connect back through the public reverse-proxy origin.
// The backend value is useful for server-side configuration, but it may contain
// a container hostname that is not resolvable from the user's browser.
export function publicWebSocketUrl(locationLike = window.location) {
  const protocol = locationLike.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${locationLike.host}/ws`;
}
